// src/redux/reducers/statsReducer.js

import {
    FETCH_STATS_REQUEST,
    FETCH_STATS_SUCCESS,
    FETCH_STATS_FAILURE,
    APPROVE_ALL_REQUEST,
    SYNC_REQUEST,
    SAVE_LANGUAGE_REQUEST,
    SAVE_RATING_REQUEST,
    UPGRADE_POPUP_REQUEST,
    THEME_APP_EXTENSION_POPUP,
    THEME_APP_EXTENSION_POPUP_SUCCESS,
} from "../actions/statsActions";

const initialState = {
    loading: false,
    stats: [],
    error: "",
    themeAppExtension: null,
};

const statsReducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_STATS_REQUEST:
        return { ...state, loading: true };
    case FETCH_STATS_SUCCESS:
        return {
            ...state,
            loading: false,
            syncing: false,
            stats: action.payload,
            error: "",
        };
    case FETCH_STATS_FAILURE:
        return {
            ...state,
            loading: false,
            syncing: false,
            stats: [],
            error: action.payload,
        };
    case APPROVE_ALL_REQUEST:
        return { ...state, loading: true };
    case SYNC_REQUEST:
        return { ...state, syncing: true };
    case SAVE_LANGUAGE_REQUEST:
        return { ...state };
    case SAVE_RATING_REQUEST:
        return { ...state };
    case UPGRADE_POPUP_REQUEST:
        return { ...state, loading: true };
    case THEME_APP_EXTENSION_POPUP:
        return { ...state, loading: true };
    case THEME_APP_EXTENSION_POPUP_SUCCESS:
        return {
            ...state,
            themeAppExtension: action.payload,
            loading: false,
        };
    default:
        return state;
    }
};

export default statsReducer;
